export const ADMIN_UID = 'TziRul3MM5bFbIjm4cfmeZ6IeCC3';
